import api from '@/api';
import { TLoginRequest } from '@/api/user';
import { addNotificationDanger } from '@/store/slices/notificationsSlice';
import { TAccount } from '@/types/users';
import { getXDeviceCode } from '@/utils/cookie';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const login = createAsyncThunk<TAccount | undefined, TLoginRequest>(
    'account/login',
    async (data, thunkApi) => {
        try {
            return await api.user.login(data);
        } catch (e) {
            thunkApi.dispatch(addNotificationDanger({ text: e as string }));
        }
    },
);

export const checkAuth = createAsyncThunk<TAccount | undefined>(
    'account/checkAuth',
    async () => {
        if (!getXDeviceCode()) {
            return;
        }
        try {
            return await api.user.checkAuth();
        } catch (e) {
            return undefined;
        }
    },
);

